var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiRrDatabaseClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "db-clock-cut"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.6,
    cy: 17.6,
    r: 5.6,
    style: {
      fill: "black"
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#db-clock-cut)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 6,
    rx: 7.5,
    ry: 2.8,
    style: {
      fill: "none",
      stroke: "var(--color-greyscale-800)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6v11.5c0 1.55 3.36 2.8 7.5 2.8",
    style: {
      fill: "none",
      stroke: "var(--color-greyscale-800)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6v5",
    style: {
      fill: "none",
      stroke: "var(--color-greyscale-800)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.5c0 1.55 3.36 2.8 7.5 2.8",
    style: {
      fill: "none",
      stroke: "var(--color-greyscale-800)"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 3.6,
    style: {
      fill: "none",
      stroke: "var(--color-greyscale-800)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.6v2l1.4.9",
    style: {
      fill: "none",
      stroke: "var(--color-greyscale-800)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrDatabaseClock);
export default __webpack_public_path__ + "static/media/fi-rr-database-clock.669c624d4fe1e5804d7b0c2e5ab6ce8b.svg";
export { ForwardRef as ReactComponent };